import { configureStore } from "@reduxjs/toolkit";

import listingTypeReducer from "./slices/listingTypeSlice";
import userIdReducer from "./slices/userIdSlice";

export default configureStore({
  reducer: {
    userId: userIdReducer,
    listingType: listingTypeReducer
  }
});
